// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-form {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin-bottom: 20px;
    width:70%;
    overflow:scroll;
  
}

.form-title {
    text-align: center;
    /* color: #333; */
    margin-bottom: 20px;
}

.form-input {
    margin: 10px 0;
    padding: 10px;
    width: 100%;
    max-width: 400px;
    border: 1px solid #ccc;
    border-radius: 4px;
    transition: border-color 0.3s;
}

.form-input:focus {
    border-color: #007bff;
    outline: none;
}

.section {
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
   
    
}

.subheading-input {
    margin-top: 15px;
    font-weight: bold;
    width: 100%;
    max-width: 400px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    height:40px;
}

.subheading-input:focus {
    border-color: #007bff;
    outline: none;
}

.paragraph-input {
   
    margin-top: 15px;
    width: calc(100% - 20px);
    max-width: 400px;
    /* Adjusted for margin */
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    height:40px;
    
}

.paragraph-input:focus {
    border-color: #007bff;
    outline: none;
}

button {
    /* background-color: #007bff; */
    /* color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
    margin-top: 10px; */
}

/* button:hover {
    background-color: #0056b3;
} */

.add-section-btn {
    background-color: #28a745;
    width:150px;
    height:50px;
    border-radius: 5px;
    margin: 0px 0px;
    padding: 20px;
}

.add-section-btn:hover {
    background-color: #218838;
}

.add-paragraph-btn {
    background-color: #28a745;
    margin: 10px 0px;
    width:150px;
    height:50px;
    border-radius: 5px;
   
    margin-top:30px;
    

}

.add-paragraph-btn:hover {
    background-color: #218838;
}

.submit-btn {
    background-color: #007bff;
    width:150px;
    height:50px;
    border-radius: 5px;
    margin: 10px 0px;
    padding:20px;
}

.submit-btn:hover {
    background-color: #0056b3;
}

@media screen and (max-width:768px){
    .blog-form {
            background-color: #ffffff;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            padding: 20px;
            margin: 20px auto;
            width: 100%;
            overflow: scroll;
    
        }

        .form-input {
            margin: 10px 0;
            padding: 10px;
            width: 80%;
            max-width: 400px;
            border: 1px solid #ccc;
            border-radius: 4px;
            transition: border-color 0.3s;
        }
    
        .form-input:focus {
            border-color: #007bff;
            outline: none;
        }
    
        .section {
            margin-bottom: 15px;
            display: flex;
            flex-direction: column;
    
    
        }
    
        .subheading-input {
            margin-top: 15px;
            font-weight: bold;
            width: 80%;
            max-width: 400px;
            padding: 10px;
            border: 1px solid #ccc;
            border-radius: 4px;
            height: 40px;
        }
    
        .subheading-input:focus {
            border-color: #007bff;
            outline: none;
        }
    
        .paragraph-input {
    
            margin-top: 15px;
            width: 80%;
            max-width: 400px;
            /* Adjusted for margin */
            padding: 10px;
            border: 1px solid #ccc;
            border-radius: 4px;
            height: 40px;
    
        }
    
        .paragraph-input:focus {
            border-color: #007bff;
            outline: none;
        }
    
       
    
        .add-section-btn {
            background-color: #28a745;
            width: 150px;
            height: 50px;
            border-radius: 5px;
            margin: 0px 0px;
            padding: 20px;
        }
    
        .add-section-btn:hover {
            background-color: #218838;
        }
    
        .add-paragraph-btn {
            background-color: #28a745;
            margin: 10px 0px;
            width: 150px;
            height: 50px;
            border-radius: 5px;
    
            margin-top: 30px;
    
    
        }
    
        .add-paragraph-btn:hover {
            background-color: #218838;
        }
    
        .submit-btn {
            background-color: #007bff;
            width: 150px;
            height: 50px;
            border-radius: 5px;
            margin: 10px 0px;
            padding: 20px;
        }
    
        .submit-btn:hover {
            background-color: #0056b3;
        }
}

`, "",{"version":3,"sources":["webpack://./src/Styles/BlogForm.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;;AAEnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;;;AAG1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;;IAEI,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;;AAEf;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B;;;;;;uBAMmB;AACvB;;AAEA;;GAEG;;AAEH;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,kBAAkB;;IAElB,eAAe;;;AAGnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;YACQ,yBAAyB;YACzB,kBAAkB;YAClB,yCAAyC;YACzC,aAAa;YACb,iBAAiB;YACjB,WAAW;YACX,gBAAgB;;QAEpB;;QAEA;YACI,cAAc;YACd,aAAa;YACb,UAAU;YACV,gBAAgB;YAChB,sBAAsB;YACtB,kBAAkB;YAClB,6BAA6B;QACjC;;QAEA;YACI,qBAAqB;YACrB,aAAa;QACjB;;QAEA;YACI,mBAAmB;YACnB,aAAa;YACb,sBAAsB;;;QAG1B;;QAEA;YACI,gBAAgB;YAChB,iBAAiB;YACjB,UAAU;YACV,gBAAgB;YAChB,aAAa;YACb,sBAAsB;YACtB,kBAAkB;YAClB,YAAY;QAChB;;QAEA;YACI,qBAAqB;YACrB,aAAa;QACjB;;QAEA;;YAEI,gBAAgB;YAChB,UAAU;YACV,gBAAgB;YAChB,wBAAwB;YACxB,aAAa;YACb,sBAAsB;YACtB,kBAAkB;YAClB,YAAY;;QAEhB;;QAEA;YACI,qBAAqB;YACrB,aAAa;QACjB;;;;QAIA;YACI,yBAAyB;YACzB,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,eAAe;YACf,aAAa;QACjB;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;YACzB,gBAAgB;YAChB,YAAY;YACZ,YAAY;YACZ,kBAAkB;;YAElB,gBAAgB;;;QAGpB;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;YACzB,YAAY;YACZ,YAAY;YACZ,kBAAkB;YAClB,gBAAgB;YAChB,aAAa;QACjB;;QAEA;YACI,yBAAyB;QAC7B;AACR","sourcesContent":[".blog-form {\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    margin-bottom: 20px;\n    width:70%;\n    overflow:scroll;\n  \n}\n\n.form-title {\n    text-align: center;\n    /* color: #333; */\n    margin-bottom: 20px;\n}\n\n.form-input {\n    margin: 10px 0;\n    padding: 10px;\n    width: 100%;\n    max-width: 400px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    transition: border-color 0.3s;\n}\n\n.form-input:focus {\n    border-color: #007bff;\n    outline: none;\n}\n\n.section {\n    margin-bottom: 15px;\n    display: flex;\n    flex-direction: column;\n   \n    \n}\n\n.subheading-input {\n    margin-top: 15px;\n    font-weight: bold;\n    width: 100%;\n    max-width: 400px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    height:40px;\n}\n\n.subheading-input:focus {\n    border-color: #007bff;\n    outline: none;\n}\n\n.paragraph-input {\n   \n    margin-top: 15px;\n    width: calc(100% - 20px);\n    max-width: 400px;\n    /* Adjusted for margin */\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    height:40px;\n    \n}\n\n.paragraph-input:focus {\n    border-color: #007bff;\n    outline: none;\n}\n\nbutton {\n    /* background-color: #007bff; */\n    /* color: white;\n    padding: 10px 15px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    margin-top: 10px; */\n}\n\n/* button:hover {\n    background-color: #0056b3;\n} */\n\n.add-section-btn {\n    background-color: #28a745;\n    width:150px;\n    height:50px;\n    border-radius: 5px;\n    margin: 0px 0px;\n    padding: 20px;\n}\n\n.add-section-btn:hover {\n    background-color: #218838;\n}\n\n.add-paragraph-btn {\n    background-color: #28a745;\n    margin: 10px 0px;\n    width:150px;\n    height:50px;\n    border-radius: 5px;\n   \n    margin-top:30px;\n    \n\n}\n\n.add-paragraph-btn:hover {\n    background-color: #218838;\n}\n\n.submit-btn {\n    background-color: #007bff;\n    width:150px;\n    height:50px;\n    border-radius: 5px;\n    margin: 10px 0px;\n    padding:20px;\n}\n\n.submit-btn:hover {\n    background-color: #0056b3;\n}\n\n@media screen and (max-width:768px){\n    .blog-form {\n            background-color: #ffffff;\n            border-radius: 8px;\n            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n            padding: 20px;\n            margin: 20px auto;\n            width: 100%;\n            overflow: scroll;\n    \n        }\n\n        .form-input {\n            margin: 10px 0;\n            padding: 10px;\n            width: 80%;\n            max-width: 400px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n            transition: border-color 0.3s;\n        }\n    \n        .form-input:focus {\n            border-color: #007bff;\n            outline: none;\n        }\n    \n        .section {\n            margin-bottom: 15px;\n            display: flex;\n            flex-direction: column;\n    \n    \n        }\n    \n        .subheading-input {\n            margin-top: 15px;\n            font-weight: bold;\n            width: 80%;\n            max-width: 400px;\n            padding: 10px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n            height: 40px;\n        }\n    \n        .subheading-input:focus {\n            border-color: #007bff;\n            outline: none;\n        }\n    \n        .paragraph-input {\n    \n            margin-top: 15px;\n            width: 80%;\n            max-width: 400px;\n            /* Adjusted for margin */\n            padding: 10px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n            height: 40px;\n    \n        }\n    \n        .paragraph-input:focus {\n            border-color: #007bff;\n            outline: none;\n        }\n    \n       \n    \n        .add-section-btn {\n            background-color: #28a745;\n            width: 150px;\n            height: 50px;\n            border-radius: 5px;\n            margin: 0px 0px;\n            padding: 20px;\n        }\n    \n        .add-section-btn:hover {\n            background-color: #218838;\n        }\n    \n        .add-paragraph-btn {\n            background-color: #28a745;\n            margin: 10px 0px;\n            width: 150px;\n            height: 50px;\n            border-radius: 5px;\n    \n            margin-top: 30px;\n    \n    \n        }\n    \n        .add-paragraph-btn:hover {\n            background-color: #218838;\n        }\n    \n        .submit-btn {\n            background-color: #007bff;\n            width: 150px;\n            height: 50px;\n            border-radius: 5px;\n            margin: 10px 0px;\n            padding: 20px;\n        }\n    \n        .submit-btn:hover {\n            background-color: #0056b3;\n        }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
